<template>
  <div class="m-viewport" v-if="ready">
    <userinfo :login_flag="login" :info="ua"/>

    <div class="m-page-view" v-if="!lock">
      <div class="page-tab main-swiper">

        <!-- Add Pagination -->
        <div class="tab-hd" slot="pagination"></div>        

        <swiper ref="pageSwiper" :options="swiperOptions" class="swiper-body">
          <swiper-slide class="swiper-no-swiping">
            <pagemain/>
          </swiper-slide>
          <swiper-slide class="swiper-no-swiping">
            <rank/>
          </swiper-slide>
        </swiper>

      </div>

      <shop/>
    </div>
    <div class="m-lock" v-else>
      <p>活动9月1日10点开始，敬请期待</p>
    </div>

    <!-- <buyView/> -->
    <item-tips ref="tips"></item-tips>
  </div>
</template>

<script>
import userinfo from '@/components/userinfo'
import buyView from '@/components/buy'
import pagemain from '@/components/main'
import rank from '@/components/rank'
import shop from '@/components/shop'

export default {
  name: 'App',
  components: {
    userinfo,
    buyView,
    pagemain,
    rank,
    shop,
  },
  data (){
    return {
      swiperOptions : {
        pagination: {
          el: '.tab-hd',
          clickable: true,
          bulletClass: 'u-btn',
          bulletActiveClass: 'active',      
          renderBullet: function (index, className) {
            return '<div class="' + className + ' tab-' + (index + 1) + '"></div>';
          },
        },        
      },
      lock : false,
    }
  },
  props : {
      ready : {
          default : false,
      },
      login : {
          default : 0,
      },      
      ua : {
          default : () => [],
      },
      evt_info : {
          default : () => [],
      },                            
  },  
}
</script>

<style>
.m-viewport{
    position: relative;
    width: 750px;
    min-height: 6207px;
    margin: -6px auto 0;
    padding-top: 1190px;
    background-image: url(~@/assets/images/body.jpg);
    background-size: 100% auto !important;
    background-repeat: no-repeat;
    background-position: top center;
    box-sizing: border-box;
    overflow-x: hidden;
    color: #876c4a;
    background-color: #720d0c;  
}

.m-lock{
  display: flex;
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background-color: #000;
  justify-content: center;
  align-items: center;
  color: #fff;
}

.m-page-view{

}

.swiper-body{
  margin-top: -13px;
}

.main-swiper{
  position: relative;
  margin-bottom: 78px;
}

.main-swiper::after{
    content: '';
    display: block;
    position: absolute;
    width: 142px;
    height: 117px;
    bottom: -23px;
    right: 0;
    background-image: url(~@/assets/images/layer-ck.png);
    pointer-events: none;
    z-index: 10;
    animation: npc 3s ease-out 2s infinite forwards;
}

.main-swiper::before{
    content: '';
    display: block;
    position: absolute;
    width: 663px;
    height: 991px;
    left: 50%;
    top: -915px;
    transform: translateX(-55%);
    background-image: url(~@/assets/images/layer-f.png);
    pointer-events: none;
    z-index: 10;
}


.main-swiper .tab-hd {
    display: flex;
    justify-content: space-between;
    padding: 0 16px;
}

.main-swiper .tab-hd .u-btn{
    width: 361px;
    height: 113px;
    background-repeat: no-repeat;
}

.main-swiper .u-btn.tab-1 {
    background-image: url(~@/assets/images/btn-tab-1.png);
}

.main-swiper .u-btn.tab-1.active {
    background-image: url(~@/assets/images/btn-tab-1-active.png);
}

.main-swiper .u-btn.tab-2 {
    background-image: url(~@/assets/images/btn-tab-2.png);
}

.main-swiper .u-btn.tab-2.active {
    background-image: url(~@/assets/images/btn-tab-2-active.png);
}

@keyframes npc {
  0% {
    transform: translate3d(1rem, 0, 0)
  }

  30% {
    transform: translateZ(0)
  }

  40% {
    transform: translate3d(1rem, -.5rem, 0)
  }

  60% {
    transform: translate3d(-.3rem, -1rem, 0) rotate(20deg)
  }

  to {
    transform: translate3d(2rem, -1.5rem, 0)
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue